import instance from 'api/instance';
import { ICreateEposTransaction } from './types';

export const createEposTransaction: ICreateEposTransaction = (data) =>
  instance.post('/epos', data);
